module.exports = __webpack_public_path__ + "static/img/onozuka_02.7ee762b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/onozuka_02.jpg
// module id = 7lkP
// module chunks = 0